
import React from 'react';
import { AdminLayout } from '@/components/admin/AdminLayout';
import { CertificatesManageContent } from '@/components/admin/certificates/CertificatesManageContent';

export default function CertificatesManage() {
  return (
    <AdminLayout>
      <CertificatesManageContent />
    </AdminLayout>
  );
}
